import { sendApiRequest } from "../lib/helper";

export class HelperService {
    static variableObject: any = {}
    static getKeplerEnvironmentVariable = async (variableName: string, doNotUseLocalStorage?: boolean): Promise<string | undefined> => {
        if (!this.variableObject[variableName]) {
            const localStorageKey = `LOCAL_STORAGE_${variableName}`;
            const valueFromLocalStorage = localStorage.getItem(localStorageKey);
            if (!valueFromLocalStorage || doNotUseLocalStorage) {
                try {
                    const variableValue = await sendApiRequest(`/api/kepler/getEnvironmentVariable?variableName=${variableName}`, "GET");
                    this.variableObject[variableName] = variableValue?.value;
                    if (variableValue.value) {
                        if(!doNotUseLocalStorage)
                        {
                            localStorage.setItem(localStorageKey, variableValue.value);
                        }
                        return variableValue.value;
                    }
                    else {
                        return undefined;
                    }
                }
                catch (err) {
                    console.log("Unable to retreive variable", err);
                    return undefined;
                }
            }
            else {
                this.variableObject[variableName] = valueFromLocalStorage;
                return valueFromLocalStorage;
            }
        }
        else {
            return this.variableObject[variableName];
        }
    }
}
